/**
* Copyright (C), 2012-2019, Sichuan Xiaoka Technology Co., Ltd.
* name: 系统设置--角色管理--表单
**/
<template>
  <div id="organizationForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="140px">
      <el-form-item label="机构Logo" prop="logo">
        <up-img :file.sync="form.logo" width="100" height="100"></up-img>
      </el-form-item>
      <el-form-item label="机构名称" prop="fullName">
        <el-input style="width: 300px" v-model="form.fullName" maxlength="30" placeholder="请设置机构名称"></el-input>
      </el-form-item>
      <el-form-item label="机构简称" prop="name">
        <el-input style="width: 300px" v-model="form.name" maxlength="10" placeholder="请设置机构简称"></el-input>
      </el-form-item>
      <el-form-item label="机构标识码" prop="organizationCode">
        <el-input style="width: 300px" v-model="form.organizationCode" maxlength="15" placeholder="请设置机构标识码"></el-input>
      </el-form-item>
      <el-form-item label="登录页主标题" prop="mainTitle" v-if="form.type == 1">
        <el-input style="width: 300px" v-model="form.mainTitle" maxlength="10"
                  placeholder="登录页左侧的主标题"></el-input>
      </el-form-item>
      <el-form-item label="登录页副标题" prop="viceTitle" v-if="form.type == 1">
        <el-input style="width: 300px" v-model="form.viceTitle" maxlength="14"
                  placeholder="登录页左侧的副标题"></el-input>
      </el-form-item>
      <el-form-item :label="form.type == 1?'总机构联系人':'机构联系人'" prop="contactsName">
        <el-input style="width: 300px" v-model="form.contactsName" maxlength="10"
                  placeholder="请设置公司联系人"></el-input>
      </el-form-item>
      <el-form-item :label="form.type == 1?'总机构联系电话':'机构联系电话'" prop="contactsPhone">
        <el-input style="width: 300px" v-model="form.contactsPhone" maxlength="11"
                  placeholder="请设置公司联系电话"></el-input>
      </el-form-item>
      <el-form-item label="菜单权限" prop="menuIds">
        <p class="util-remark">
          请勾选要授权给分公司的功能，系统不支持授权的功能已自动禁用
        </p>
        <!--一级菜单 -->
        <div class="menu" v-for="(level1, i) in menuList" :key="i">
          <div class="main-menu">
            <el-checkbox size="mini" v-model="level1.check" :label="level1.menuName" @change="checkFn(level1)"
                         :disabled="form.type == 1 || (form.type == 2 && level1.isDisabled == 1) || (level1.isDisabled == 1 && !id)"></el-checkbox>
          </div>

          <!--一级菜单下的按钮-->
          <div class="children-menu-btn" v-if="level1.buttons && level1.buttons.length > 0">
            <el-checkbox v-for="(level3, k) in level1.buttons" :key="k" :label="level3.name" v-model="level3.check"
                         @change="checkFn(level3, level1)"
                         :disabled="form.type == 1 || (form.type == 2 && level3.isDisabled == 1) || (level3.isDisabled == 1 && !id)"></el-checkbox>
          </div>

          <!--二级菜单-->
          <div class="children-menu" v-if="level1.children && level1.children.length > 0">
            <div v-for="(level2, j) in level1.children" :key="j">
              <el-checkbox v-model="level2.check" :label="level2.menuName" @change="checkFn(level2, level1)"
                           :disabled="form.type == 1 || (form.type == 2 && level2.isDisabled == 1) || (level2.isDisabled == 1 && !id)"></el-checkbox>

              <!--二级菜单下的按钮-->
              <div class="children-menu-btn" v-if="level2.buttons && level2.buttons.length > 0">
                <el-checkbox v-for="(level3, k) in level2.buttons" :key="k" :label="level3.name" v-model="level3.check"
                             @change="checkFn(level3, level2, level1)"
                             :disabled="level3.id == 39 || form.type == 1 || (form.type == 2 && level3.isDisabled == 1) || (level3.isDisabled == 1 && !id)"></el-checkbox>
              </div>

              <!--三级菜单-->
              <div class="children-menu" v-if="level2.children && level2.children.length > 0">
                <div v-for="(level3, k) in level2.children" :key="k">
                  <el-checkbox v-model="level3.check" :label="level3.menuName" @change="checkFn(level3, level2, level1)"
                               :disabled="form.type == 1 || (form.type == 2 && level3.isDisabled == 1) || (level3.isDisabled == 1 && !id)"></el-checkbox>

                  <!--三级菜单下的按钮-->
                  <div class="children-menu-btn" v-if="level3.buttons && level3.buttons.length > 0">
                    <el-checkbox v-for="(level4, k) in level3.buttons" :key="k" :label="level4.name"
                                 v-model="level4.check" @change="checkFn(level4, level3, level2, level1)"
                                 :disabled="form.type == 1 || (form.type == 2 && level4.isDisabled == 1) || (level4.isDisabled == 1 && !id)"></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="saveClick">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "organizationForm",
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type, // 编辑机构类型
      form: {},
      loading: false,
      menuList: [], // 菜单
      rules: {
        // 表单校验
        logo: [
          {required: true, message: "请设置机构Logo", trigger: ["blur"]},
        ],
        fullName: [
          {required: true, message: "请设置公司的名称", trigger: ["blur"]},
        ],
        name: [
          {required: true, message: "请设置公司简称", trigger: ["blur"]},
        ],
        organizationCode: [
          {required: true, message: "请设置机构标识码", trigger: ["blur"]},
        ],
        mainTitle: [
          {required: true, message: "请设置页面主标题", trigger: ["blur"]},
        ],
        viceTitle: [
          {required: true, message: "请设置页面副标题", trigger: ["blur"]},
        ],
        contactsPhone: [
          {required: true, pattern: /^1\d{10}$/, message: "请输入正确的联系电话"},
        ],
        contactsName: [
          {required: true, message: "请设置公司联系人", trigger: ["blur"]},
        ],
        menuIds: [
          {
            required: true,
            message: "请至少勾选一个选项",
            trigger: ["change"],
          },
        ],
      },
    };
  },
  async created() {
    this.getMenuListFn();
  },
  methods: {

    /**
     * 选中事件
     * @param target 操作对象
     * @param parent 操作对象祖先集
     */
    checkFn(target, ...parent) {
      this.$forceUpdate();
      if (target.check && parent) {
        // 勾选状态且父级存在
        parent.map((item) => item.check = target.check); // 上面几级状态变为勾选
      }

      if (target.children?.length > 0) {
        // 下一级状态同步变化
        target.children.map((item) => {
          if (!((this.form.type == 2 && item.isDisabled == 1) || (item.isDisabled == 1 && !this.id))) {
            // 以下权限禁用且不勾选
            item.check = target.check;
          }
          this.checkFn(item); // 下n级
        });
      }

      if (target.buttons?.length > 0) {
        // 下一级状态同步变化
        target.buttons.map((item) => {
          item.check = target.check;
        });
      }


      this.menuCodesFn();
    },

    /* 选中菜单id集合拼接成菜单权限id集合与按钮权限集合 */
    menuCodesFn() {
      let menuIds = [];
      let buttonIds = [];

      this.menuList.map((level1) => {
        if (level1.check) {
          menuIds.push(level1.id);
        }

        if (level1.children?.length > 0) {


          level1.children.map((level2) => {
            level2.check && (menuIds.push(level2.id));
            if (level2.buttons?.length > 0) {
              level2.buttons.map((level3) => {
                level3.check && (buttonIds.push(level3.id))
              });
            }

            if (level2.children?.length > 0) {
              level2.children.map((level3) => {
                level3.check && (menuIds.push(level3.id))
                if (level3.buttons?.length > 0) {
                  level3.buttons.map((level4) => {
                    level4.check && (buttonIds.push(level4.id))
                  });
                }
              });
            }
          });
        }

        if (level1.buttons?.length > 0) {
          console.log(level1.buttons);
          level1.buttons.map((level3) => {
            level3.check && (buttonIds.push(level3.id))
          });
        }
      });
      this.$set(this.form, "menuIds", menuIds);
      this.$set(this.form, "buttonIds", buttonIds);
    },

    /* 点亮菜单 */
    setRoleFn(menuIds, btnIds) {

      let lightUp = (list, type) => {

        list.map(item => {
          if (type == 'menu') {
            if (menuIds.includes(item.id)) {
              this.$set(item, 'check', true)
            }
            if (item.children?.length) {
              lightUp(item.children, 'menu')
            }
            if (item.buttons?.length) {
              lightUp(item.buttons, 'button')
            }
          } else {
            if (btnIds.includes(item.id)) {
              this.$set(item, 'check', true)
            }
          }
        })

      }

      lightUp(this.menuList, 'menu');


      // menuIds.map((id) => {
      //   // 菜单按钮
      //   this.menuList.map((item) => {
      //     // 菜单树
      //     if (Number(id) == Number(item.id)) {
      //       // 一级菜单
      //       item.check = true;
      //     }
      //     if (item.children && item.children.length > 0) {
      //       // 二级菜单
      //       item.children.map((i) => {
      //         if (Number(id) == Number(i.id)) {
      //           // 一级菜单
      //           i.check = true;
      //         }
      //         if (i.buttons && i.buttons.length > 0) {
      //           btnIds.map((id) => {
      //             // 操作按钮
      //             i.buttons.map((ii) => {
      //               if (Number(id) == Number(ii.id)) {
      //                 // 一级菜单
      //                 ii.check = true;
      //               }
      //             });
      //           });
      //         }
      //       });
      //     }
      //   });
      // });
    },

    /* 获得菜单 */
    async getMenuListFn() {
      let url = "/api/v1/manage/menu";
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.menuList = data.data;
        if (this.id) {
          this.getRoleFn();
        }
      }
    },

    /* 接口请求--get（单个） */
    async getRoleFn() {
      // 获得
      let url = "/api/v1/manage/organization/" + this.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.form = data.data;

        this.setRoleFn(data.data.menuIds || [], data.data.buttonIds || []);
        this.menuCodesFn()
      }
    },

    /* 接口请求--put */
    async putFn(params) {
      let url = "/api/v1/manage/organization";
      let data = await this.$axios.put(url, params);
      this.loading = false;
      if (data && data.code == 1) {
        this.$message.success("保存成功！");
        this.$router.go(-1);
      }
    },

    /* 接口请求--post */
    async postFn(params) {
      let url = "/api/v1/manage/organization";
      let data = await this.$axios.post(url, params);
      this.loading = false;
      if (data && data.code == 1) {
        this.$message.success("保存成功！");
        this.$router.go(-1);
      }
    },

    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let params = this.$utils.deepCopyFn(this.form);
          console.log(params, 1122);
          params.menuIds = params.menuIds ? params.menuIds.join(",") : "";
          params.buttonIds = params.buttonIds ? params.buttonIds.join(",") : "";
          if (this.id) {
            this.putFn(params);
          } else {
            this.postFn(params);
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    }
  },
};
</script>

<style lang="less">
#organizationForm {
  padding: 20px 40px;
  max-width: 1000px;

  .el-form {
    .el-form-item__label {
      color: #606266;
      font-weight: 500;
    }
    
    .el-input__inner {
      border-radius: 6px;
    }
  }

  .util-remark {
    color: #909399;
    font-size: 12px;
    margin-bottom: 12px;
  }

  .menu {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px 16px;
    background: #fafbfc;
    transition: all 0.2s;

    &:hover {
      border-color: #c0c4cc;
    }

    .main-menu {
      height: 36px;
      line-height: 36px;
      font-weight: 500;
      
      .el-checkbox__label {
        font-size: 14px;
        color: #303133;
      }
    }

    .children-menu {
      line-height: 32px;
      margin-left: 24px;
      padding-left: 12px;
      border-left: 2px solid #e4e7ed;

      .el-checkbox {
        margin: 0;
        margin-right: 24px;
        
        .el-checkbox__label {
          font-size: 13px;
          color: #606266;
        }
      }
    }

    .children-menu-btn {
      line-height: 32px;
      margin-left: 24px;
      padding: 4px 0 4px 12px;
      background: #f5f7fa;
      border-radius: 4px;
      margin-top: 4px;
      margin-bottom: 4px;

      .el-checkbox {
        margin: 0;
        margin-right: 16px;
        
        .el-checkbox__label {
          font-size: 12px;
          color: #909399;
        }
      }
    }
  }

  .menu + .menu {
    margin-top: 12px;
  }

  // 保存按钮区域
  .el-form-item:last-child {
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
    
    .el-button {
      min-width: 100px;
      border-radius: 6px;
    }
  }
}
</style>
